import React from 'react'

function First() {
  return (
    <>
        <section className="team-area-content">
            <div className="container">
                <div className="lower-content">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12 col-sm-12 text-center">
                    <div className="team-img-box">
                        <img src="assets/img/team/team_img_detalis.png" alt="img" />
                    </div>
                    </div>
                    <div className="text-column col-lg-6 col-md-12 col-sm-12">
                    <div className="s-about-content pl-30 wow fadeInRight"
                        data-animation="fadeInRight"
                        data-delay=".2s" >
                        <span>Founder</span>
                        <h2>Rosalina D. William</h2>
                        <p>
                        Pleasure and praising pain was born and I will give you a complete
                        account of the systems, and expound the actually teachings of the
                        great explorer of the truth, the master-builder of human uts
                        happiness. No one rejects, dislikes, or avoids pleasure itself,
                        because it is pleasure, but because those who do not know how to
                        pursue pleasure rationally Nor who loves or pursues or desires to
                        obtain pain of itself.
                        </p>
                        <ul>
                        <li>
                            <div className="icon">
                            <i className="fal fa-envelope" /> <strong>Email</strong>
                            </div>
                            <div className="text">info@webexample.com</div>
                        </li>
                        <li>
                            <div className="icon">
                            <i className="fal fa-phone" /> <strong>Phone</strong>
                            </div>
                            <div className="text">980-786-098-09</div>
                        </li>
                        <li>
                            <div className="icon">
                            <i className="fal fa-map-marker-alt" />
                            <strong>Address</strong>
                            </div>
                            <div className="text">12/A, Miranda City Hall, NYC</div>
                        </li>
                        <li>
                            <div className="icon">
                            <i className="fal fa-globe" />
                            <strong>Website</strong>
                            </div>
                            <div className="text">www.webexample.com</div>
                        </li>
                        </ul>
                        <div className="social">
                        <a href="https://www.facebook.com">
                            <i className="fab fa-facebook-f" />
                        </a>
                        <a href="https://twitter.com">
                            <i className="fab fa-twitter" />
                        </a>
                        <a href="https://www.behance.net">
                            <i className="fab fa-behance" />
                        </a>
                        <a href="https://www.youtube.com">
                            <i className="fab fa-youtube" />
                        </a>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default First